import { gql } from '@apollo/client';

export default gql`
  mutation CreateUntrustedTalentProfile(
    $email: Email!
    $general_info: TalentGeneralInfoInput!
    $source_company_id: ID
    $job_application_data: JobApplicationInput
    $origin: TalentOriginEnum
    $invitation_uid: String
    $tags: [ID]
    $recruiter_info: RecruiterInfoInput
    $device_id: String
    $stid: String
    $documents: [TalentDocumentInput]
    $employee_name_who_referred: String
    $is_agree_to_marketing_materials: Boolean
    $is_agree_to_sms: Boolean
    $is_agree_to_terms_and_conditions: Boolean
    $marketing_source: TalentMarketingSourceEnum
    $is_bilingual: Boolean
    $languages: [TalentLanguageEnum]
    $work_type: [TalentWorkTypeEnum]
    $companies: [ID]
  ) {
    createUntrustedTalentProfile(
      email: $email
      origin: $origin
      job_application_data: $job_application_data
      general_info: $general_info
      source_company_id: $source_company_id
      invitation_uid: $invitation_uid
      tags: $tags
      recruiter_info: $recruiter_info
      device_id: $device_id
      stid: $stid
      documents: $documents
      employee_name_who_referred: $employee_name_who_referred
      is_agree_to_marketing_materials: $is_agree_to_marketing_materials
      is_agree_to_sms: $is_agree_to_sms
      is_agree_to_terms_and_conditions: $is_agree_to_terms_and_conditions
      marketing_source: $marketing_source
      is_bilingual: $is_bilingual
      languages: $languages
      work_type: $work_type
      companies: $companies
    )
  }
`;
